import React from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { RowType } from '../../../../redux/slices/oldBuilder';
import { CohortRow } from '../../Cohorts';
import { MAX_BREAKDOWN_COHORTS } from '../../../../config/constants';
import AddSegmentAction from './AddSegmentAction';

interface IProps {
  enableAddSegments: boolean;
}

const Segments = ({ enableAddSegments }: IProps) => {
  const segments = useAppSelector(
    ({ builder }) => builder[RowType.breakdownCohorts],
  );

  const allowAddSegment =
    enableAddSegments && segments.length < MAX_BREAKDOWN_COHORTS;

  return (
    <>
      <AddSegmentAction allowAddSegment={allowAddSegment} />

      {segments?.length > 0 &&
        segments.map((cohortRow, rowIndex) => (
          <CohortRow
            key={`segment-cohort-row-${rowIndex}`}
            rowMeta={{
              rowType: RowType.breakdownCohorts,
              rowIndex,
            }}
            cohortRow={cohortRow}
            allowRemove
            removeActionTooltip={{
              content: 'Remove Segment',
            }}
          />
        ))}
    </>
  );
};

export default Segments;
